import AbortService from "@rmp/core/services/abortService";
import { Api } from "@rmp/api-gateway";
import BaseApiController from "@rmp/core/api/base/baseApiController";

const organizationUrl = process.env.VUE_APP_BASE_API_URL!;

export default class BaseOrganizationController extends BaseApiController<Api<any>> {
	constructor(abortService: AbortService) {
		super(config => new Api<any>(config), organizationUrl, abortService);
	}
}
